module.exports = __webpack_public_path__ + "assets/img/medin_shop.1b6cf5af.png";